export default function FacebookIcon({
                                         size = 40
                                     }: {
    size?: number | string
}) {
    return <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="8" fill="#1877F2"/>
        <path
            d="M27.7852 28.9688L28.6719 23.1875H23.125V19.4375C23.125 17.8555 23.8984 16.3125 26.3828 16.3125H28.9062V11.3906C28.9062 11.3906 26.6172 11 24.4297 11C19.8594 11 16.875 13.7695 16.875 18.7813V23.1875H11.7969V28.9688H16.875V42.9453C17.8945 43.1055 18.9375 43.1875 20 43.1875C21.0625 43.1875 22.1055 43.1055 23.125 42.9453V28.9688H27.7852Z"
            fill="white"/>

    </svg>

}